import { Component, Inject, OnInit } from '@angular/core';
import { UsersApplicationsService } from '../../../modal-open-application/users-applications.service';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { LoadingService } from 'src/app/shared/loading.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-configurations-studies-modal',
  templateUrl: './configurations-studies-modal.component.html',
  styleUrls: ['./configurations-studies-modal.component.scss'],
})
export class ConfigurationsStudiesModalComponent implements OnInit {
  studyResponse: any = {};
  studyForm: FormGroup;
  loading: boolean = false;
  deleteConfirmation: boolean = false;
  closeConfirmation: boolean = false;
  application: string = '';

  constructor(
    private fb: FormBuilder,
    private usersApplicationsService: UsersApplicationsService,
    private dialog: MatDialog,
    private loadingService: LoadingService,
    private route: Router,
    public dialogRef: MatDialogRef<ConfigurationsStudiesModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { UserId: string; studyId: string; study: any }
  ) {}

  ngOnInit(): void {
    this.loading = false;
    this.application = this.loadingService.getLoadingState();
    this.studyForm = this.fb.group({
      name: ['', Validators.required],
    });
    this.studyResponse = this.data.study;
  }

  ngAfterViewInit(): void {
    this.loading = true;
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  deleteScreenCall(screenCall: boolean): void {
    this.deleteConfirmation = screenCall;
  }

  onSubmit() {
    if (this.studyForm.valid) {
      const updatedStudyData = {
        ...this.studyResponse,
        name: this.studyForm.get('name')?.value,
        updatedAt: new Date().toISOString(),
      };
      if (this.application === 'guia') {
        this.usersApplicationsService
          .updateGuiaStudies(this.studyResponse._id, updatedStudyData)
          .subscribe(
            (res) => {
              this.dialogRef.close({ updated: true, study: updatedStudyData });
            },
            (error) => {
              console.error('Erro ao atualizar o estudo:', error);
            }
          );
      } else {
        this.usersApplicationsService
          .updateStudy(this.studyResponse._id, updatedStudyData)
          .subscribe(
            (response) => {
              this.dialogRef.close({ updated: true,  study: updatedStudyData });
            },
            (error) => {
              console.error('Erro ao atualizar o estudo:', error);
            }
          );
      }
    }
  }

  onDeleteStudy() {
    if (this.studyResponse._id) {

      if (this.application === 'guia') {
        this.usersApplicationsService.deleteGuiaStudies(this.studyResponse._id).subscribe((res) => {
          this.dialogRef.close({
            deleted: true,
            studyId: this.studyResponse._id,
          });
        })
      } else {
        this.usersApplicationsService
          .deleteStudy(this.studyResponse._id)
          .subscribe(
            (res) => {
              this.dialogRef.close({
                deleted: true,
                studyId: this.studyResponse._id,
              });
            },
            (error) => {
              console.error('Erro ao excluir o estudo:', error);
            }
          );
      }
    }
  }
}
